import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { getJoinOrganizationSuggestion } from '@hotjar/webapp/domains/acquisition/join-organization-suggestion';
import type { JoinOrganizationSuggestion } from '@hotjar/webapp/domains/acquisition/join-organization-suggestion/types';
import { useCurrentUser } from '@hotjar/user';
import { useUserExperiment } from '@hotjar/webapp/hooks/useExperiment';

export const useJoinOrganizationSuggestion = (): UseQueryResult<
  JoinOrganizationSuggestion,
  Error
> => {
  const { data: user } = useCurrentUser();
  const { inVariant1 } = useUserExperiment('acq_join_organization_experiment', user);

  return useQuery('join-organization-suggestion', getJoinOrganizationSuggestion, {
    retry: false,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    enabled: inVariant1,
  });
};
